module.exports = __webpack_public_path__ + "img/my-ticket.5a906980.svg";